/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AlertDto
 */
export interface AlertDto {
    /**
     *
     * @type {number}
     * @memberof AlertDto
     */
    alertId?: number;
    /**
     *
     * @type {string}
     * @memberof AlertDto
     */
    deviceIdentity?: string;
    /**
     *
     * @type {string}
     * @memberof AlertDto
     */
    deviceFriendlyName?: string;
    /**
     *
     * @type {string}
     * @memberof AlertDto
     */
    serviceModelDeviceGroupTag?: string;
    /**
     *
     * @type {string}
     * @memberof AlertDto
     */
    siteDeviceGroupTag?: string;
    /**
     *
     * @type {string}
     * @memberof AlertDto
     */
    siteName?: string;
    /**
     *
     * @type {string}
     * @memberof AlertDto
     */
    organisationId?: string;
    /**
     *
     * @type {string}
     * @memberof AlertDto
     */
    organisationName?: string;
    /**
     *
     * @type {number}
     * @memberof AlertDto
     */
    alertCount?: number;
    /**
     *
     * @type {string}
     * @memberof AlertDto
     */
    type?: AlertDtoTypeEnum;
    /**
     *
     * @type {string}
     * @memberof AlertDto
     */
    description?: string;
    /**
     *
     * @type {Date}
     * @memberof AlertDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof AlertDto
     */
    expiredAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof AlertDto
     */
    updatedAt?: Date;
}

/**
 * @export
 */
export const AlertDtoTypeEnum = {
    Unknown: "Unknown",
    FrequentFaults: "FrequentFaults",
    ShortDuration: "ShortDuration",
    NoActivity: "NoActivity",
    ZerokWh: "ZerokWh",
    PowerLoss: "PowerLoss",
    FrequentReconnects: "FrequentReconnects",
    EnergyPriceChargingSuspended: "EnergyPriceChargingSuspended",
    LowEnergyMidSession: "LowEnergyMidSession",
} as const;
export type AlertDtoTypeEnum =
    (typeof AlertDtoTypeEnum)[keyof typeof AlertDtoTypeEnum];

/**
 * Check if a given object implements the AlertDto interface.
 */
export function instanceOfAlertDto(value: object): value is AlertDto {
    return true;
}

export function AlertDtoFromJSON(json: any): AlertDto {
    return AlertDtoFromJSONTyped(json, false);
}

export function AlertDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): AlertDto {
    if (json == null) {
        return json;
    }
    return {
        alertId: json["alertId"] == null ? undefined : json["alertId"],
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        deviceFriendlyName:
            json["deviceFriendlyName"] == null
                ? undefined
                : json["deviceFriendlyName"],
        serviceModelDeviceGroupTag:
            json["serviceModelDeviceGroupTag"] == null
                ? undefined
                : json["serviceModelDeviceGroupTag"],
        siteDeviceGroupTag:
            json["siteDeviceGroupTag"] == null
                ? undefined
                : json["siteDeviceGroupTag"],
        siteName: json["siteName"] == null ? undefined : json["siteName"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        organisationName:
            json["organisationName"] == null
                ? undefined
                : json["organisationName"],
        alertCount: json["alertCount"] == null ? undefined : json["alertCount"],
        type: json["type"] == null ? undefined : json["type"],
        description:
            json["description"] == null ? undefined : json["description"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        expiredAt:
            json["expiredAt"] == null ? undefined : new Date(json["expiredAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
    };
}

export function AlertDtoToJSON(value?: AlertDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        alertId: value["alertId"],
        deviceIdentity: value["deviceIdentity"],
        deviceFriendlyName: value["deviceFriendlyName"],
        serviceModelDeviceGroupTag: value["serviceModelDeviceGroupTag"],
        siteDeviceGroupTag: value["siteDeviceGroupTag"],
        siteName: value["siteName"],
        organisationId: value["organisationId"],
        organisationName: value["organisationName"],
        alertCount: value["alertCount"],
        type: value["type"],
        description: value["description"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        expiredAt:
            value["expiredAt"] == null
                ? undefined
                : value["expiredAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
    };
}
